// Vendors
import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Components
import { BuildersDropdown } from '../../../components';
import { DirectMessage } from './components';
import LoadMoreButton from '../LoadMoreButton';

const DirectMessages = ({
  IS_ADMIN,
  isFIP,
  unreadMessages,
  messages,
  setMessages,
  loading,
  dmTabIDOpen,
  setDmTabIDOpen,
  postNewMessage,
  postDMReply,
  handleMarkAsRead,
  showOnlyUnreadDM,
  setShowOnlyUnreadDM,
  setOffset,
  offset,
  limit,
  hasMore,
  setHasMore,
  setProjectMessages

}) => {
  const [newMessage, setNewMessage] = useState({
    subject: '',
    body: ''
  });
  const [showPostNewMessage, setShowPostNewMessage] = useState(false);
  const [showEmptyFieldError, setShowEmptyFieldError] = useState(false);
  const [builderList, setBuilderList] = useState(null);
  const [builderListLoading, setBuilderListLoading] = useState(false);
  const [builderProjects, setBuilderProjects] = useState(null);
  const [builderProjectsLoading, setBuilderProjectsLoading] = useState(true);
  const [recipient, setRecipient] = useState(0);
  const [selectedProjectIDs, setSelectedProjectIDs] = useState([]);
  const [directMessagesData, setDirectMessagesData] = useState([]);
  const [messagesFilterUIDs, setMessagesFilterUIDs] = useState([]);
  const userType = isFIP ? 'Producer' : 'Builder';
  let _isSubscribed = false;

  const areFieldsFilledOut = () => {
    if (!newMessage.subject || !newMessage.body) {
      setShowEmptyFieldError(true);
      return false;
    }

    setShowEmptyFieldError(false);
    return true;
  };

  const handleFilterByBuilder = (builderID) => {
    const allMessagesData = [...messages];

    if (builderID !== '') {
      const filteredData = allMessagesData.filter(
        ({ builder: { ID } }) => ID === builderID
      );

      setDirectMessagesData(filteredData);
    } else {
      setDirectMessagesData([...allMessagesData]);
    }
  };

  const handleTagProjectCheckboxToggle = (newID) => {
    if (!newID) return;

    let newArr = [...selectedProjectIDs];

    // if id is already present in array, remove.
    if (newArr.includes(newID)) {
      newArr = selectedProjectIDs.filter((id) => id !== newID);
    } else {
      // else add.
      newArr.push(newID);
    }

    setSelectedProjectIDs(newArr);
  };

  const handleShowOnlyUnreadMessages = () => {
    setOffset(0);
    setHasMore(true);
    setMessages(null);
    setMessagesFilterUIDs([]);
    setDirectMessagesData([]);
    setSelectedProjectIDs([]);
    setShowOnlyUnreadDM(!showOnlyUnreadDM)
  };

  const handleInputChange = (event) => {
    const updatedMessage = { ...newMessage };
    updatedMessage[event.target.name] = event.target.value;
    setNewMessage(updatedMessage);
  };

  const handleSendNewMessage = () => {
    if (!areFieldsFilledOut()) return;

    postNewMessage(newMessage, 0, recipient, selectedProjectIDs);
  };

  useEffect(() => {
    if (messages) {
      if (IS_ADMIN) {
        let builders = [];

        messages.map((message) => {
          const alreadyExists = builders.findIndex(
            (builder) => builder.builder.ID === message.builder.ID
          );

          if (alreadyExists >= 0) {
            if (message.unread === true) {
              builders[alreadyExists].unread += 1;
            }
          } else {
            builders.push({
              builder: message.builder,
              unread: message.unread === true ? 1 : 0
            });
          }

          builders.sort((a, b) =>
            a.builder['last_name'] < b.builder['last_name']
              ? -1
              : a.builder['last_name'] > b.builder['last_name']
              ? 1
              : 0
          );
        });

        setMessagesFilterUIDs([...builders]);
      }

      if (showOnlyUnreadDM) {
        setDirectMessagesData([
          ...messages.filter((message) => message.unread)
        ]);
      } else {
        setDirectMessagesData([...messages]);
      }
    }
  }, [messages, showOnlyUnreadDM]);

  useEffect(() => {
    if (!IS_ADMIN || !showPostNewMessage) return;
    if (builderList !== null) return;

    setBuilderListLoading(true);
    _isSubscribed = true;

    axios({
      method: 'post',
      url: `${window.wlPipConfig.ajaxUrl}?action=${
        isFIP ? 'wl_fip_get_producers' : 'wl_pip_get_builders'
      }`
    })
      .then(({ data: { success, data } }) => {
        if (_isSubscribed) {
          if (success) {
            // Sort list by last name.
            data.sort((a, b) =>
              a.last_name < b.last_name ? -1 : a.last_name > b.last_name ? 1 : 0
            );

            setBuilderList(data);
          } else {
            setBuilderList(null);
          }

          setBuilderListLoading(false);
          _isSubscribed = false;
        }
      })
      .catch((error) => {
        console.log(error);
        setBuilderListLoading(false);
      });

    return () => (_isSubscribed = false);
  }, [showPostNewMessage]);

  useEffect(() => {
    if (!recipient) return;

    _isSubscribed = true;
    setBuilderProjectsLoading(true);
    setSelectedProjectIDs([]);

    const formData = new FormData();
    formData.append('action', 'wl_pip_admin_get_project_ids');
    formData.append('builder_id', recipient);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        if (_isSubscribed) {
          if (success) {
            setBuilderProjects(data);
          }

          _isSubscribed = false;
          setBuilderProjectsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return () => (_isSubscribed = false);
  }, [recipient]);

  return (
    <>
      <div className="direct-message__container">
        <div
          className={`direct-message__toggle-btn ${
            showPostNewMessage
              ? 'u--display-none u--margin-0'
              : 'u--display-block'
          }`}
        >
          <button
            className="btn btn--gray-darkest btn--outline"
            type="button"
            onClick={() => setShowPostNewMessage(!showPostNewMessage)}
          >
            <span className="btn__content">
              <span className="btn__text">
                {showPostNewMessage && 'Hide'} Send New Message to
                {IS_ADMIN ? ` ${userType}` : ' Admin'}
              </span>
            </span>
          </button>
        </div>
        <div
          className={`form__field messages__unread-checkbox ${
            showPostNewMessage ? 'messages__unread-checkbox--wide' : ''
          }`}
        >
          <label className={`form__checkbox`} htmlFor="show_only_unread_dms">
            Show only unread messages.{' '}
            <input
              id="show_only_unread_dms"
              type="checkbox"
              name="show_only_unread_dms"
              checked={showOnlyUnreadDM}
              onChange={() => handleShowOnlyUnreadMessages()}
              disabled={unreadMessages.dm === 0 && !showOnlyUnreadDM}
            />
          </label>
        </div>

        {showPostNewMessage && (
          <>
            <div
              className="direct-message__new-comment"
              style={{
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {IS_ADMIN === true && (
                <>
                  <div className="form__field">
                    <label className="form__label u--font-weight-bold">
                      {userType}
                    </label>
                    {builderListLoading && (
                      <p className="is-loading" style={{ height: '45px' }}>
                        &nbsp;
                      </p>
                    )}
                    {!builderListLoading && builderList && (
                      <div className="form__select form__select--lg form__input--no-shadow">
                        <BuildersDropdown
                          builders={builderList}
                          userType={userType}
                          name="recipient"
                          className="form__input form__input--lg"
                          value={recipient}
                          onChange={(event) =>
                            setRecipient(event.currentTarget.value)
                          }
                        />
                      </div>
                    )}
                  </div>
                  {recipient !== null &&
                    builderProjects &&
                    builderProjects.length > 0 && (
                      <div className="form__field">
                        <label className="form__label u--font-weight-bold">
                          Tag Project
                        </label>
                        {builderProjectsLoading && (
                          <p
                            className={
                              builderProjectsLoading ? 'is-loading' : ''
                            }
                            style={{ height: '30px' }}
                          >
                            --
                          </p>
                        )}
                        {!builderProjectsLoading &&
                          Object.values(builderProjects).map(
                            ({ ID, post_title }) => {
                              return (
                                <label key={ID} className="form__checkbox">
                                  <input
                                    type="checkbox"
                                    name="project_id"
                                    checked={selectedProjectIDs.includes(ID)}
                                    onChange={() => {
                                      handleTagProjectCheckboxToggle(ID);
                                    }}
                                  />{' '}
                                  {post_title}
                                </label>
                              );
                            }
                          )}
                      </div>
                    )}
                </>
              )}
              <div className="form__field">
                <label className="form__label u--font-weight-bold">
                  Subject
                </label>
                {showEmptyFieldError && newMessage.subject === '' && (
                  <small className="form__help">
                    <span className="form__help-icon icon icon--md perc-icon-caret-right"></span>
                    Subject can not be empty.
                  </small>
                )}
                <input
                  type="text"
                  name="subject"
                  className="form__input"
                  value={newMessage.subject}
                  onChange={(event) => handleInputChange(event)}
                />
              </div>
              <div className="form__field">
                <label className="form__label u--font-weight-bold">
                  Message
                </label>
                {showEmptyFieldError && newMessage.body === '' && (
                  <small className="form__help">
                    <span className="form__help-icon icon icon--md perc-icon-caret-right"></span>
                    Message body can not be empty.
                  </small>
                )}
                <textarea
                  type="textarea"
                  name="body"
                  className="form__textarea form__textarea--no-shadow u--margin-bottom-20"
                  value={newMessage.body}
                  onChange={(event) => handleInputChange(event)}
                />
              </div>
              <button
                className={`u--margin-right-10 btn btn--gold ${
                  loading ? 'btn--loading' : ''
                }`}
                type="button"
                disabled={!newMessage}
                onClick={() => handleSendNewMessage()}
              >
                <span className="btn__content">
                  <span className="btn__text">
                    {isFIP ? 'Send a Message' : 'Send New Direct Message'}
                  </span>
                </span>
              </button>
              <button
                className="btn btn--white"
                type="button"
                onClick={() => setShowPostNewMessage(!showPostNewMessage)}
              >
                <span className="btn__content">
                  <span className="btn__text">Cancel</span>
                </span>
              </button>
            </div>
            <hr style={{ width: '100%' }} />
          </>
        )}
      </div>

      {messagesFilterUIDs.length > 0 && (
        <div className="form__select form__select--lg u--margin-bottom-30">
          <select
            name="filter_by_builder"
            className="form__input form__input--lg"
            defaultValue=""
            onChange={(event) =>
              handleFilterByBuilder(event.currentTarget.value)
            }
          >
            <option value="">{`-- Filter Messages by ${
              isFIP ? 'Producer' : 'Builder'
            } --`}</option>
            {messagesFilterUIDs.map(
              (
                {
                  unread,
                  builder: { ID, first_name, last_name, company, user_email }
                },
                index
              ) => (
                <option key={`${index}-${ID}`} value={ID}>
                  {last_name && last_name}
                  {first_name && `, ${first_name}`} ({user_email})
                  {company && ` - ${company}`}
                  {unread > 0 && ` - (${unread} unread)`}
                </option>
              )
            )}
          </select>
        </div>
      )}

      {directMessagesData !== null
        ? directMessagesData.map((message, index) => (
            <DirectMessage
              key={message.id}
              IS_ADMIN={IS_ADMIN}
              loading={loading}
              dmTabIDOpen={dmTabIDOpen}
              setDmTabIDOpen={setDmTabIDOpen}
              postDMReply={postDMReply}
              builder={message.builder ?? []}
              handleMarkAsRead={handleMarkAsRead}
              {...message}
            />
          ))
        : 'No Direct Messages.'}
      {hasMore &&
         <LoadMoreButton
            limit={limit}
            offset={offset}
            loading={loading}
            setOffset={setOffset}
            />
        }
    </>
  );
};

export default DirectMessages;
